module.exports = __webpack_public_path__ + "assets/img/d8fb-om.svg";